import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type UpdateSelectorProps = {
  label: string;
  value: string;
  onValueChange: (value: string) => void;
  updateOptions?: string[];
};

export const UpdateSelector = ({ 
  label, 
  value, 
  onValueChange, 
  updateOptions 
}: UpdateSelectorProps) => {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium">{label}:</span>
      <Select
        value={value}
        onValueChange={onValueChange}
      >
        <SelectTrigger className="w-[240px]">
          <SelectValue placeholder="Select update time" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All updates</SelectItem>
          {updateOptions?.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};